import DeviceInfo from 'react-native-device-info';
import moment from 'moment';
import AsyncStorage from '@react-native-async-storage/async-storage';

export type ClientAnalyticsPayload = {
  'X-User-Id'?: string;
  'X-Employee-Id'?: string;
  'X-Owner-Id'?: string;
  'X-Phone-Number'?: string;
  'X-Device-Id': string;
  'X-Device-Name': string;
  'X-Device-Unique-Id': string;
  'X-Device-Brand': string;
  'X-Device-Carrier': string | null;
  'X-Device-Type': string;
  'X-Device-First-Install-Time': string;
  'X-Emulator': string;
  'X-Device-System-Version': string;
  'X-Device-Version': string;
  'X-App-Build-Number': string;
  'X-App-Bundle-Id': string;
  'X-Last-Login-At'?: string;
};

export const buildClientAnalytics = async (userHints?: {
  userId?: string;
  employeeId?: string;
  ownerId?: string;
  phoneNumber?: string;
  lastLoginAt?: Date;
}): Promise<ClientAnalyticsPayload> => {
  const deviceUniqueId = await DeviceInfo.getUniqueId();
  const brand = DeviceInfo.getBrand();
  const carrier = await DeviceInfo.getCarrier();
  const deviceId = DeviceInfo.getDeviceId();
  const deviceType = DeviceInfo.getDeviceType();
  const deviceName = await DeviceInfo.getDeviceName();
  const firstInstallTime = await DeviceInfo.getFirstInstallTime();
  const isEmulator = await DeviceInfo.isEmulator();
  const systemVersion = DeviceInfo.getSystemVersion();
  const version = DeviceInfo.getVersion();
  const buildNumber = DeviceInfo.getBuildNumber();
  const bundleId = DeviceInfo.getBundleId();

  // Optionally persist last login time
  if (userHints?.lastLoginAt) {
    try {
      await AsyncStorage.setItem(
        'bp_last_login_at',
        userHints.lastLoginAt.toISOString(),
      );
    } catch {}
  }
  let storedLastLogin: string | null = null;
  try {
    storedLastLogin = await AsyncStorage.getItem('bp_last_login_at');
  } catch {}

  return {
    'X-User-Id': userHints?.userId,
    'X-Employee-Id': userHints?.employeeId,
    'X-Owner-Id': userHints?.ownerId,
    'X-Phone-Number': userHints?.phoneNumber,
    'X-Device-Id': deviceId,
    'X-Device-Name': deviceName,
    'X-Device-Unique-Id': deviceUniqueId,
    'X-Device-Brand': brand,
    'X-Device-Carrier': carrier,
    'X-Device-Type': deviceType,
    'X-Device-First-Install-Time': moment(
      (firstInstallTime as unknown as number)
        ? (firstInstallTime as unknown as Date)
        : new Date(),
    ).toISOString(true),
    'X-Emulator': isEmulator.toString(),
    'X-Device-System-Version': systemVersion,
    'X-Device-Version': version,
    'X-App-Build-Number': buildNumber,
    'X-App-Bundle-Id': bundleId,
    'X-Last-Login-At': storedLastLogin || userHints?.lastLoginAt?.toISOString(),
  };
};
